"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Flags = require("./Flags");
var _default = exports["default"] = _Flags.flagSprite;